import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'accounting' })
  export class AccountingPipe implements PipeTransform {
    transform(value: any): any {
      let formattedValue = value.charAt(0) === '-' ?
             '(' + value.substring(1, value.length) + ')' :
             value;

      return formattedValue
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/accounting.Pipe.ts